export const RATING_OPTIONS = [
  { value: '', label: 'Tất cả số sao' },
  ...[5, 4, 3, 2, 1].map((value) => ({ value: String(value), label: `${value} sao` })),
];

export const formatReviewDate = (value) => (value ? new Date(value).toLocaleString('vi-VN') : '—');

export const getRideReviewErrorMessage = (error) => error?.response?.data?.message
  || error?.response?.data?.reason
  || 'Không thể xử lý yêu cầu đánh giá';

// Keyed by the :direction route segment — one API/label set per review
// direction ("Khách -> Tài xế" vs "Tài xế -> Khách"), each backed by its
// own table/reviewId namespace (RideReview vs RideCustomerReview).
export const REVIEW_DIRECTIONS = {
  driver: {
    subjectLabel: 'Tài xế',
    reviewerLabel: 'Khách hàng đánh giá',
  },
  customer: {
    subjectLabel: 'Khách hàng',
    reviewerLabel: 'Tài xế đánh giá',
  },
};
